import { render, staticRenderFns } from "./PlantUML.vue?vue&type=template&id=5948a113"
import script from "./PlantUML.vue?vue&type=script&lang=js"
export * from "./PlantUML.vue?vue&type=script&lang=js"
import style0 from "./PlantUML.vue?vue&type=style&index=0&id=5948a113&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports